import script from "./Tr069Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Tr069Settings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__